"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Film = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Film_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.218 2.092C0 2.52 0 3.08 0 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 15 2.08 15 3.2 15h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 1 13.92 1 12.8 1H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874ZM2 11a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5h.75a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5H2Zm10.75.5a.5.5 0 0 1 .5-.5H14a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5h-.75a.5.5 0 0 1-.5-.5v-1.5ZM2 2.5a.5.5 0 0 0-.5.5v1.5A.5.5 0 0 0 2 5h.75a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2Zm10.75.5a.5.5 0 0 1 .5-.5H14a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-.75a.5.5 0 0 1-.5-.5V3ZM2 6.75a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h.75a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 0-.5-.5H2Zm10.75.5a.5.5 0 0 1 .5-.5H14a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-.75a.5.5 0 0 1-.5-.5v-1.5ZM5.5 5.65v4.7c0 .496.537.809.97.566l4.198-2.35a.647.647 0 0 0 0-1.131L6.47 5.085a.651.651 0 0 0-.971.565Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Film_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Film;
exports["default"] = _default;